import Vue from 'vue';
import subscriberListTransformer from './../../transformers/subscriberList';

const success = (resolve) => {
  resolve();
};

const failed = (errors, reject) => {
  reject(subscriberListTransformer.fetch(errors));
};

export default (id, subscriberList) => (
  new Promise((resolve, reject) => {
    Vue.$http
      .put(`subscriberList/${id}`, subscriberList)
      .then(() => {
        success(resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/subscriberList/update.js